import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-dark" }, "Authors", -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-2" }
const _hoisted_7 = { class: "symbol symbol-50px me-5" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-6"
}
const _hoisted_11 = { class: "text-muted d-block fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/general/gen024.svg",
              "aria-hidden": "true"
            })
          ])
        ]),
        _createVNode(_component_Dropdown2)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([{ 'mb-7': _ctx.list.length - 1 !== index }, "d-flex align-items-center"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: item.avatar,
              class: "",
              alt: ""
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", _hoisted_10, _toDisplayString(item.name), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(item.description), 1)
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}